import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalLoadingComponent } from '../app-components/modal-loading/modal-loading.component';

@Injectable({
  providedIn: 'root'
})
export class ModalLoadingService {

  constructor(private modalService: NgbModal) { }

  private count = 0;
  private modalRef: any;

  open(msg = '') {
    this.count++;
    if (this.count === 1) {
      this.modalRef = this.modalService.open(ModalLoadingComponent, {
        centered: true,
        size: 'sm',
        beforeDismiss: () => {
          return this.count === 0;
        },
      });
    }
    if (msg !== '') {
      this.modalRef.componentInstance.msg = msg;
    }
  }

  close() {
    this.count--;
    if (this.count === 0) {
      this.modalRef.close();
    }
  }
}
